/**
 * editCorrespondentModule 新建/编辑通讯员
 * author: Qian.qianchen 2019-09-29
 */
'use strict';
angular.module('editCorrespondentModule', []).
controller('editCorrespondentController', ['$scope', '$q', 'trsHttpService', 'modalDialog', 'trsspliceString', '$stateParams', '$validation', '$element', '$state', '$timeout',
    function($scope, $q, trsHttpService, modalDialog, trsspliceString, $stateParams, $validation, $element, $state, $timeout) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                correspondentId: $stateParams.correspondentId
            };
            $scope.data = {
                userInfo: {

                }
            };
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            ($scope.status.correspondentId == 0 ? initNewData() : initEditData()).then(() => {

            });
        }
        /**
         * [initEditData description] 获取通讯员详情
         * @return {[type]} [description]
         */
        function initEditData() {
            let defer = $q.defer();
            let params = {
                serviceid: "mlf_commuser",
                methodname: "findCommUser",
                ObjectId: $scope.status.correspondentId
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then((data) => {
                $scope.data.userInfo = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initNewData description] 通讯员新建信息
         * @return {[type]} [description]
         */
        function initNewData() {
            let defer = $q.defer();
            $scope.data.userInfo = {
                "TELEPHONE": "",
                "MOBILEPHONE": "",
                "POST": "",
                "ZIPCODE": "",
                "EMAIL": "",
                "PRESS": "",
                "COMPANY": "",
                "BANKCARDNUMBER": "",
                "CATEGORY": "",
                "ALIPAY": "",
                "USERTYPE": "",
                "ADDRESS": "",  
                "USERNAME": "",
                "DEPT": "",
                "BANKACCOUNT": "",
                "COMMUSERID": 0,
                "FGDSFZ": "",
            };
            defer.resolve();
            return defer.promise;
        }

        /**
         * [goBack description] 返回
         * @return {[type]} [description]
         */
        $scope.goBack = function() {
            $state.go('manageconfig.groupmanage.correspondent');
        }

        /**
         * [save description] 保存
         * @return {[type]} [description]
         */
        $scope.save = function() {
            let defer = $q.defer();
            $scope.correspondentForm.$pending = {};
            $validation.validate($scope.correspondentForm)
                .success(function() {
                    let params = {
                        serviceid: "mlf_commuser",
                        methodname: "saveCommUser",
                        ObjectId: $scope.status.correspondentId,
                        UserName: $scope.data.userInfo.USERNAME,
                        Company: $scope.data.userInfo.COMPANY,
                        Post: $scope.data.userInfo.POST,
                        Category: $scope.data.userInfo.CATEGORY,
                        Dept: $scope.data.userInfo.DEPT,
                        Press: $scope.data.userInfo.PRESS,
                        Address: $scope.data.userInfo.ADDRESS,
                        ZipCode: $scope.data.userInfo.ZIPCODE,
                        Email: $scope.data.userInfo.EMAIL,
                        Telephone: $scope.data.userInfo.TELEPHONE,
                        MobilePhone: $scope.data.userInfo.MOBILEPHONE,
                        FgdSfz: $scope.data.userInfo.FGDSFZ,
                        BankAccount: $scope.data.userInfo.BANKACCOUNT,
                        BankCardNumber: $scope.data.userInfo.BANKCARDNUMBER,
                        alipay: $scope.data.userInfo.ALIPAY,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        $stateParams.correspondentId = JSON.parse(data);
                        $state.transitionTo($state.current, $stateParams, {
                            reload: true
                        });
                        $timeout(function() {
                            modalDialog.saveModel("保存成功", "", "success");
                        }, 500);
                        defer.resolve();
                    });
                }).error(function(msg) {
                    angular.invalidPosition($scope.correspondentForm, $element);
                    defer.reject();
                });
            return defer.promise;
        }
    }
]);